import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchClients } from "#modules/clients/infra/fetchClients.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const clientsQuery = () => ({
  queryKey: queryKeys.clients.all,
  queryFn: fetchClients,
  staleTime: STALE_TIME,
});
